import React, { Component } from 'react';
import * as _ from 'lodash';
import memoizeOne from 'memoize-one';
import moment from 'moment';
import { AgGridReact } from '@ag-grid-community/react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import toastr from 'toastr';
import { EditMode, VIEWS } from '../../HelperMethods/constants';
import * as LocalStorageUtils from '../../HelperMethods/LocalStorageUtils';
import ActionsColumnRenderer from '../common/ActionsColumnRenderer';
import { RESOURCES } from '../../HelperMethods/role-resource-constants';
import * as enums from '../../HelperMethods/enums';
import {
  GRID_OPTIONS,
  LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY,
  LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY,
  LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY,
  LOCAL_STORAGE_TASK_LIST_SORT_MODEL,
  LOCAL_STORAGE_TASK_PIN_COLUMN_LIST,
  onColumnResized,
  onDragStopped,
  onColumnPinned,
  onDisplayedColumnsChanged,
  TASK_TABLE_COLUMN_MAP,
  TASK_VIEW_TASK_GRID_OPTIONS,
  DEFAULT_TASK_TABLE_COLUMN_ORDER,
} from '../../HelperMethods/AgGridConstants';
import { CONTAINERS, resetView, pushView } from '../common/cardNavigationComponent/cardNavigationRedux';
import ParentTaskCard from '../common/parentTaskCard/ParentTaskCard';
import TaskCard from '../common/taskCard/TaskCard';
import TaskAssigneeCard from '../common/taskAssigneeCard/TaskAssigneeCard';
import * as TaskUtilities from '../../HelperMethods/TaskUtilities';
import logUtils from '../../HelperMethods/LogUtils';
import DeleteRecurrenceTaskConfirmModal from './modals/DeleteRecurrenceTaskConfirmModal';
import { updateDeletedForRecurrenceDateForTask, deleteTask } from './TaskViewPage/redux/actions';
import TooltipComponent from './AgGridTooltipComponent';
import FilterSaveModal from './FilterSaveModal';
import * as taskViewPageActions from './TaskViewPage/redux/actions';
import {
  createFilterObjToSave,
  getGlobalAttributeToColumn,
  mapPinnedColumns,
  getAssetLevelColumns,
} from './TaskViewPage/helper';
import FilterMenuButton from './FilterButton';
import { changeFilter, changeTempfilter, updateUserConfig } from '../../actions/appActions';
import * as parentTaskCardActions from '../common/parentTaskCard/parentTaskCardRedux';
import apiService from '../../service/apiService';
import ConfirmTasksModal from './ConfirmTasksModal';

class TaskList extends Component {
  constructor() {
    super();
    this.state = {
      deleteTaskModal: {
        open: false,
        task: null,
        isdependent: false,
      },
      // state to check if clear button is clicked from the filter button
      clearClicked: false,
      filterModal: { open: false, filterModel: {}, updated: false },
      saveModal: { open: false, modalType: enums.FILTER_OPERATION.SAVE, onConfirm: () => {} },
    };
    this.taskListApi = null;
    this.confirmTasksModalRef = React.createRef();
  }

  componentDidMount() {
    this.filterModalfromLocalStorage();
    this.countDown = setInterval(() => {
      this.checkForReminder();
    }, 60000);
  }

  componentDidUpdate(prevProps) {
    // current view changed from schedulerview to task grid view
    if (
      prevProps.currentView !== this.props.currentView &&
      // prevProps.currentView === 'schedulerView' &&
      this.props.currentView === 'taskGridView'
    ) {
      this.filterModalfromLocalStorage();
    }
    const keysToIgnore = ['asset', 'assignee', 'taskType'];
    if (
      this.taskListApi &&
      !_.isEqual(
        prevProps?.rowData?.map((data) => _.omit(data, keysToIgnore)),
        this.props?.rowData?.map((data) => _.omit(data, keysToIgnore))
      )
    ) {
      const { selectedFilter = {} } = this.props;
      const { filterModel = {} } = selectedFilter;
      const updatedFilterModel = JSON.parse(JSON.stringify(this.taskListApi.getFilterModel() || {}));

      const isFilterChanged = this.checkForChangeInFilter({ updatedFilterModel, filterModel });
      if (isFilterChanged) {
        this.taskListApi.setFilterModel(filterModel);
      }
      this.taskListApi?.setRowData(this.props.rowData);
    } else if (this.props?.rowData?.length === 0) {
      this.taskListApi?.setRowData([]);
    }
  }

  componentWillUnmount() {
    if (this.countDown) {
      clearInterval(this.countDown);
    }
  }

  onCellClicked = (event) => {
    const { resetViewInNavigationComponent, setManageTaskView, tasksEditMode, pushViewInNavigationComponent } =
      this.props;
    if (event.colDef.field === 'taskTypeName') {
      resetViewInNavigationComponent(CONTAINERS.GRID_VIEW, {
        component: TaskCard,
        props: {
          taskId: event.data.id,
          setManageTaskView,
          tasksEditMode,
        },
      });
    } else if (event.colDef.field === 'parentTaskName' && event.data.parentTaskId) {
      resetViewInNavigationComponent(CONTAINERS.GRID_VIEW, {
        component: ParentTaskCard,
        props: { parentTaskId: event.data.parentTaskId, tasksEditMode },
      });
    } else if (event.colDef.field === 'taskNumber') {
      navigator.clipboard.writeText(event?.data?.taskNumber).then(
        () => {
          toastr.success('Copied!');
        },
        () => {
          toastr.error('Copy failed!');
        }
      );
    } else if (event.colDef.field === 'assignedToUserName') {
      resetViewInNavigationComponent(CONTAINERS.GRID_VIEW, {
        component: TaskAssigneeCard,
        props: {
          taskId: event.data.id,
          setManageTaskView,
          tasksEditMode,
          pushTaskCard: () => {
            pushViewInNavigationComponent(CONTAINERS.GRID_VIEW, {
              component: TaskCard,
              props: {
                taskId: event.data.id,
                setManageTaskView,
                tasksEditMode,
              },
            });
          },
        },
      });
    }
  };

  setRowStyle = (params) => {
    if (params.data.priority === enums.TASK_PRIORITY.CRITICAL.text) {
      return { color: 'black', background: '#e6deeb' };
    }
    return { background: params.data.isMultipleAssignee ? '#fffbe0' : 'inherit' };
  };

  onSelectionChangedOrRowReloaded = (event) => {
    const { onRowSelectionChanged, selectedTasks = [] } = this.props;
    if (event.type === 'rowSelected') {
      const selectedNodes = event.api.getSelectedNodes();
      const selectedTaskIds = selectedTasks.map((task) => task.id);
      const selectedRowsIds = selectedNodes.map((node) => node.data.id);
      const diffIds = selectedRowsIds
        .filter((id) => !selectedTaskIds.includes(id))
        .concat(selectedTaskIds.filter((id) => !selectedRowsIds.includes(id)));
      if (diffIds.length) {
        onRowSelectionChanged(selectedNodes.map((n) => n.data));
      }
    } else if (event.type === 'rowDataChanged') {
      const taskUpdated = [];
      const selectedTasksDict = _.keyBy(selectedTasks, 'id');
      event.api.forEachNode((node) => {
        const reqTasks = selectedTasksDict[node.data.id];
        if (reqTasks) {
          node.setSelected(true);
          taskUpdated.push(node.data);
        }
      });
      onRowSelectionChanged(taskUpdated);
    }
  };

  // eslint-disable-next-line react/sort-comp

  onDeleteTask = async (task) => {
    if (this.confirmTasksModalRef?.current) {
      this.confirmTasksModalRef?.current?.handleDeleteTasks([task]);
    }
  };

  getColumnDefsMemoizeFunc = memoizeOne((doesParentTaskExist, isSingleUserSelected, userConfig) => {
    const {
      columnOrder,
      columnWidth,
      columnVisibility,
      sortModel,
      filter: { filterModel },
      pinnedColumnsMap,
    } = LocalStorageUtils.getTaskListTableProperties(userConfig);

    const isFeatureEnabled = _.get(this.props.settings, 'featureFlags.enableAssetHierarchy', false);
    const { levelsDetails = [] } = _.get(this.props.settings, 'admin.assetHierarchy', {});
    const { globalTaskAttributes = [] } = this.props;
    const checkboxIndex = columnOrder.indexOf('checkBoxColumn');
    const actionButtonsIndex = columnOrder.indexOf('actionButtons');
    const missingColumnIndex = Math.max(checkboxIndex, actionButtonsIndex) === 1 ? 2 : 0;
    if (columnOrder.indexOf('seqNo') === -1) {
      columnOrder.splice(missingColumnIndex, 0, 'seqNo');
    }
    if (columnOrder.indexOf('assignedToUserName') === -1) {
      columnOrder.splice(missingColumnIndex, 0, 'assignedToUserName');
    }
    if (columnOrder.indexOf('assignedVendor') === -1) {
      columnOrder.splice(missingColumnIndex + 1, 0, 'assignedVendor');
    }
    const defaultColumnOrders = [...DEFAULT_TASK_TABLE_COLUMN_ORDER, ...(levelsDetails || []).map((l) => l.name)];
    const newlyAddedStaticColumns = _.difference(defaultColumnOrders, columnOrder);
    if (newlyAddedStaticColumns.length) {
      columnOrder.push(...newlyAddedStaticColumns);
    }

    if (isSingleUserSelected) {
      columnOrder.splice(columnOrder.indexOf('assignedVendor'), 1);
      columnOrder.splice(columnOrder.indexOf('assignedToUserName'), 1);
    } else {
      columnOrder.splice(columnOrder.indexOf('seqNo'), 1);
    }
    _.set(columnVisibility, 'parentTaskName', doesParentTaskExist);

    const clonedColumnsMap = _.cloneDeep(TASK_TABLE_COLUMN_MAP);
    if (isFeatureEnabled) {
      getAssetLevelColumns({ levelsDetails, clonedColumnsMap });
    }
    Object.keys(clonedColumnsMap).forEach((key) => {
      if (!_.isNil(columnVisibility) && !_.isNil(columnVisibility[key])) {
        clonedColumnsMap[key].hide = !columnVisibility[key];
      }
    });

    for (const [field, column] of Object.entries(clonedColumnsMap)) {
      if (columnWidth[field]) {
        Object.assign(column, { width: columnWidth[field] });
      }
    }

    const columns = columnOrder.map((columnKey) => clonedColumnsMap[columnKey]).filter((col) => !!col);

    getGlobalAttributeToColumn(globalTaskAttributes, columnOrder, columnVisibility, columns);

    const columnDefs = mapPinnedColumns(pinnedColumnsMap, columns);

    return {
      columnDefs,
      sortModel,
      savedFilter: filterModel,
    };
  });

  getTaskFilters = memoizeOne((allFilters) => {
    const taskFilters = Object.values(allFilters).map(({ userId, id, schema, name }) => {
      return { filter: schema, userId, id, name };
    });
    return taskFilters;
  });

  updateUserConfigFun = async (path, value) => {
    this.props.updateUserConfig(path, value);
  };

  filterModalfromLocalStorage = () => {
    const { selectedFilter = {} } = this.props;
    let filterModelToUse = {};

    const { filterModel = {}, id, isModified = false } = selectedFilter;

    if (!id || id === 'my-watchlist') {
      // new filter change on grid.
      filterModelToUse = filterModel;
    } else {
      // eslint-disable-next-line no-lonely-if
      if (isModified) {
        // grid filter is changed on the already applied filter
        filterModelToUse = filterModel;
      } else {
        // use filter from the list of filters using id...
        const allTaskFilters = this.getTaskFilters(this.props.allFilters);
        const filterDict = _.keyBy(allTaskFilters || [], 'id');
        const filter = filterDict[id];
        filterModelToUse = filter?.filter || {};
      }
    }

    this.setState(
      {
        filterModal: { open: false, filterModel: filterModelToUse, updated: isModified },
      },
      () => {
        if (this.taskListApi) {
          this.taskListApi.setFilterModel(filterModelToUse);
        }
      }
    );
  };

  deleteTaskRecurrence = (task, isOccurrence) => {
    if (TaskUtilities.isTaskOccurrenceOfRecurringAndVirtual(task)) {
      if (isOccurrence) this.deleteVirtualTask(task);
      else this.deleteTask(task.sourceRecurringTaskId);
    } else if (isOccurrence) this.deleteTask(task.id);
    else this.deleteTask(task.sourceRecurringTaskId);
  };

  closeDeleteRecurringTaskModal = () => {
    this.setState({
      deleteTaskModal: {
        open: false,
        task: null,
      },
    });
  };

  deleteVirtualTask = (task) => {
    const { allTasks, updateDeletedForRecurrenceDateForTaskAction } = this.props;
    const sourceTask = _.find(allTasks, { id: task.sourceRecurringTaskId });
    updateDeletedForRecurrenceDateForTaskAction(sourceTask, task.startTime)
      .then(() => {
        toastr.success('Task Deleted Successfully!!');
      })
      .catch((e) => {
        logUtils.logError(e, 'Task Deletion Failed!!');
      });
  };

  deleteTask = (id) => {
    const { deleteTaskAction } = this.props;
    deleteTaskAction(id)
      .then(() => {
        toastr.success('Task Deleted Successfully!!');
      })
      .catch((error) => {
        logUtils.logError(error, 'Task Deletion Failed!!');
      });
  };

  getColumnDefs = () => {
    const { selectedUserIds, rowData, userConfig } = this.props;
    const doesParentTaskDataExists = rowData?.some((task) => !!task.parentTaskId);
    const isSingleUserSelected = selectedUserIds.length === 1;
    return this.getColumnDefsMemoizeFunc(doesParentTaskDataExists, isSingleUserSelected, userConfig);
  };

  checkForChangeInFilter = ({ updatedFilterModel, filterModel }) => {
    Object.keys(updatedFilterModel).forEach((fieldId) => {
      if (fieldId.endsWith('_1')) {
        const newFieldId = fieldId.substr(0, fieldId.length - 2);
        updatedFilterModel[newFieldId] = updatedFilterModel[fieldId];
      } else {
        const newFieldId = `${fieldId}_1`;
        updatedFilterModel[newFieldId] = updatedFilterModel[fieldId];
      }
    });
    if (_.isEqual(updatedFilterModel, filterModel)) {
      return false;
    }
    return true;
  };

  handleFilterChange = (params) => {
    const { selectedFilter = {}, myWatchlist } = this.props;
    const { id, name, filterModel = {} } = selectedFilter;
    const updatedFilterModel = JSON.parse(JSON.stringify(params.api.getFilterModel() || {}));

    const isFilterChanged = this.checkForChangeInFilter({ updatedFilterModel, filterModel });
    if (!isFilterChanged || myWatchlist.selected) {
      return;
    }
    const isModified = id ? true : !_.isEmpty(updatedFilterModel);
    const selectedFilterToUpdate = { id, name, filterModel: updatedFilterModel, isModified };

    this.props.changeSelectedFilter(selectedFilterToUpdate);
    this.props.updateUserConfig('TASK_LIST', {
      TASK_LIST_FILTER_MODEL: JSON.stringify(selectedFilterToUpdate),
    });
    this.setState(() => {
      return {
        filterModal: { open: false, filterModel: updatedFilterModel, updated: isModified },
      };
    });
  };

  handleDeleteMenu = (e, id) => {
    this.setState({
      saveModal: {
        open: true,
        modalType: enums.FILTER_OPERATION.DELETE,
        onConfirm: () => {
          this.handleDeleteFilter(id);
        },
      },
    });
    e.stopPropagation();
  };

  handleUpdateMenu = (e, id) => {
    this.setState({
      saveModal: {
        open: true,
        modalType: enums.FILTER_OPERATION.UPDATE,
        idClicked: id,
        onConfirm: (name) => {
          this.handleSaveFilter(name, id);
        },
      },
    });
    e.stopPropagation();
  };

  handleMenu = ({ filter, id, name }) => {
    const isModified = false;
    const selectedFilterToUpdate = { id, name, filterModel: filter, isModified };
    this.props.handleMyWathlistTaskIds(false, []);
    this.props.changeSelectedFilter(selectedFilterToUpdate);
    this.props.updateUserConfig('TASK_LIST', {
      TASK_LIST_FILTER_MODEL: JSON.stringify(selectedFilterToUpdate),
    });
    this.setState(
      () => {
        return {
          filterModal: { open: false, filterModel: filter, updated: isModified },
        };
      },
      () => {
        this.taskListApi.setFilterModel(filter);
      }
    );
  };

  handleToggleSaveFilter = (modalType = enums.FILTER_OPERATION.SAVE) => {
    this.setState((prevState) => {
      return {
        ...prevState,
        saveModal: {
          ...prevState.saveModal,
          open: !prevState.saveModal.open,
          idClicked: null,
          modalType,
          onConfirm: (name) => {
            this.handleSaveFilter(name);
          },
        },
      };
    });
  };

  handleGridReady = (params) => {
    const { onGridReady } = this.props;
    this.taskListApi = params.api;
    const allColumnIds = [];
    // const tempFilter = _.get(this.state.filterModal, 'filterModel', {});
    // this.taskListApi.setFilterModel(tempFilter);
    onGridReady(params);
  };

  checkForReminder = () => {
    const { rowData } = this.props;
    for (const task of rowData || []) {
      const enableReminder = _.get(task, 'taskType.reminder.enableReminder', false);
      if (enableReminder) {
        const rowNode = this.taskListApi.getRowNode(task.id);
        if (rowNode) {
          rowNode.setData({ ...task, reminder: TaskUtilities.findTimeForReminder(task) });
        }
      }
    }
  };

  handleSaveFilter = async (name, FilterId) => {
    const {
      filterModal: { filterModel },
      saveModal: { modalType },
    } = this.state;
    const {
      taskViewAction,
      allFilters,
      // selectedFilter: { id: selectedFilterId },
      // changeSelectedFilter,
    } = this.props;
    let filterToSave = null;
    try {
      if (modalType === enums.FILTER_OPERATION.SAVE) {
        filterToSave = createFilterObjToSave(name, filterModel);
      } else if (modalType === enums.FILTER_OPERATION.UPDATE) {
        const reqFilter = allFilters.find(({ id }) => id === FilterId);
        if (reqFilter) {
          const reqFilterClone = _.cloneDeep(reqFilter);
          reqFilterClone.schema = filterModel;
          reqFilterClone.name = name;
          filterToSave = reqFilterClone;
        }
      }
      if (filterToSave) {
        this.handleToggleSaveFilter();
        const filter = await taskViewAction.upsertFilter(filterToSave);
        // saveFilterToLocalStorage({ id: filter.id, name: filter.name, filterModel: filter.schema, updated: false });
        // changeSelectedFilter({ id: filter.id, name: filter.name });
        this.setState(
          (prevState) => {
            return {
              ...prevState,
              filterModal: { ...prevState.filterModal, updated: false, open: false },
            };
          },
          () => {
            // removeTempFilterFromLocalStorage();
            const filterToSaveNew = { id: filter.id, name: filter.name, filterModel: filter.schema, updated: false };
            this.props.changeSelectedFilter(filterToSaveNew);
            this.props.updateUserConfig('TASK_LIST', {
              TASK_LIST_FILTER_MODEL: JSON.stringify(filterToSaveNew),
            });
          }
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  handleClearFilter = () => {
    const isModified = false;
    const selectedFilterToUpdate = {};
    this.props.changeSelectedFilter(selectedFilterToUpdate);
    this.props.updateUserConfig('TASK_LIST', {
      TASK_LIST_FILTER_MODEL: JSON.stringify(selectedFilterToUpdate),
    });
    this.props.handleMyWathlistTaskIds(false, []);
    this.setState(
      () => {
        return {
          filterModal: { open: false, filterModel: {}, updated: isModified },
        };
      },
      () => {
        this.taskListApi.setFilterModel({});
      }
    );
  };

  handleFilterMyWatchlist = async () => {
    const {
      loggedInUser: { id: userId },
      selectedFieldId,
      selectedAreas,
      handleMyWathlistTaskIds,
      setIsPageLoading,
    } = this.props;
    setIsPageLoading(true);
    this.handleClearFilter();
    const myWatchlistTasks = await apiService.getTasksWatchedByMe({
      areaIds: selectedAreas.map((a) => a.id),
      userId,
      onlyTaskIds: true,
      fieldId: selectedFieldId,
      startTime: moment(this.props.selectedDateRange.startDate).startOf('day').toDate(),
      endTime: moment(this.props.selectedDateRange.endDate).endOf('day').toDate(),
    });
    handleMyWathlistTaskIds(
      true,
      myWatchlistTasks.map((val) => val.id)
    );
    setIsPageLoading(false);
  };

  handleDeleteFilter = async (id) => {
    const {
      taskViewAction,
      selectedFilter: { id: selectedFilterId },
    } = this.props;
    try {
      this.handleToggleSaveFilter();
      const deletedFilter = await taskViewAction.deleteFilter(id);
      if (deletedFilter.id === selectedFilterId) {
        this.handleClearFilter();
        // removeFilterFromLocalStorage();
      }
    } catch (error) {
      console.error(error);
    }
  };

  dateFilter = (date) => {
    const Nminus1 = moment().subtract(2, 'days').toISOString();
    const Nplus7 = moment().add(8, 'days').toISOString();

    if (moment(date).isAfter(Nminus1) && moment(date).isBefore(Nplus7)) {
      return true;
    }
    return false;
  };

  getUserIdsfromFilter = (params) => {
    const dataFilteredFromtaskGridApi = _.get(params, 'api.rowModel.rowsToDisplay', []);

    const datadateFiltered = dataFilteredFromtaskGridApi.filter(
      (e) => e.data && e.data.startTime && this.dateFilter(e.data.startTime)
    );
    const dataFiltered = datadateFiltered
      .filter((e) => e.data && e.data.assigneeIds)
      .map((r) => r.data.assigneeIds.map((e) => e.assigneeId))
      .filter((r) => !_.isEmpty(r));

    return _.uniq(_.flatMap(dataFiltered)) || [];
  };

  handleChangeFilter = (filterObj = {}, updated = false, open = false, setFilterModal = true) => {
    this.setState(
      (prevState) => {
        return {
          ...prevState,
          filterModal: {
            open,
            filterModel: filterObj,
            updated,
          },
        };
      },
      () => {
        if (setFilterModal && this.taskListApi) {
          this.taskListApi.setFilterModel(filterObj);
        }
      }
    );
  };

  onFirstDataRendered = ({ params, sortModel, savedFilter }) => {
    if (sortModel && this.taskListApi) {
      this.taskListApi?.columnApi?.applyColumnState({
        state: sortModel,
        defaultState: { sort: null },
      });
    }

    if (savedFilter && this.taskListApi) {
      this.taskListApi.setFilterModel(savedFilter);
    }
  };

  render() {
    const { onCellClicked, setRowStyle, onSelectionChangedOrRowReloaded, getTaskFilters } = this;
    const { deleteTaskModal, filterModal, saveModal } = this.state;
    const {
      rowData,
      tasksEditMode,
      setManageTaskView,
      selectedUserIds,
      allFilters,
      currentView,
      selectedFilter,
      userConfig,
      myWatchlist,
    } = this.props;
    const { columnDefs, savedFilter, sortModel } = this.getColumnDefs(rowData, selectedUserIds);
    const allTaskFilters = getTaskFilters(allFilters);
    return (
      <>
        {currentView === VIEWS.taskGridView && (
          <FilterMenuButton
            handleClearFilter={this.handleClearFilter}
            handleMenu={this.handleMenu}
            handleUpdateMenu={this.handleUpdateMenu}
            handleDeleteMenu={this.handleDeleteMenu}
            selectedFilter={selectedFilter}
            allTaskFilters={allTaskFilters}
            filterModal={this.state.filterModal}
            handleToggleSaveFilter={this.handleToggleSaveFilter}
            handleFilterMyWatchlist={this.handleFilterMyWatchlist}
            watchlistSelected={myWatchlist.selected}
          />
        )}
        <div style={{ height: '100%' }}>
          <div className="ag-theme-balham" style={{ flex: 1, height: '100%', width: '100%' }}>
            <AgGridReact
              {...GRID_OPTIONS}
              {...TASK_VIEW_TASK_GRID_OPTIONS}
              overlayNoRowsTemplate=""
              loading={false}
              statusBar={{
                statusPanels: [
                  {
                    statusPanel: 'agTotalAndFilteredRowCountComponent',
                    align: 'left',
                  },
                ],
              }}
              columnDefs={columnDefs}
              onFirstDataRendered={(params) => this.onFirstDataRendered({ params, sortModel, savedFilter })}
              onGridReady={this.handleGridReady}
              onRowDataChanged={(params) => {
                this.taskListApi?.columnApi?.applyColumnState({
                  state: userConfig?.TASK_LIST?.[LOCAL_STORAGE_TASK_LIST_SORT_MODEL]
                    ? JSON.parse(userConfig?.TASK_LIST?.[LOCAL_STORAGE_TASK_LIST_SORT_MODEL])
                    : [],
                  defaultState: { sort: null },
                });
                if (
                  !userConfig?.TASK_LIST?.[LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY] &&
                  rowData &&
                  rowData.length > 0
                ) {
                  setTimeout(() => {
                    const allColumnIds = params.columnApi.getAllColumns().map((col) => col.getColId());
                    params.columnApi.autoSizeColumns(allColumnIds, false);
                    // works more reliably now
                  }, 50);
                }
                onSelectionChangedOrRowReloaded(params);
              }}
              onCellClicked={onCellClicked}
              getRowStyle={setRowStyle}
              frameworkComponents={{
                actionsColumnRenderer: ActionsColumnRenderer,
                descriptionTooltipComponent: TooltipComponent,
              }}
              context={{
                editItem: setManageTaskView,
                deleteItem: tasksEditMode === EditMode.PUBLISHED ? this.onDeleteTask : null,
                disableDeleteConfirmationModal: true,
                resource: RESOURCES.ENTITY.TASK,
              }}
              onCellFocused={({ api, rowIndex, column }) => {
                if (rowIndex !== null || column !== null) {
                  api.clearFocusedCell();
                }
              }}
              rowSelection="multiple"
              suppressRowClickSelection="true"
              onRowSelected={onSelectionChangedOrRowReloaded}
              onFilterChanged={(params) => {
                if (currentView === 'taskGridView') this.handleFilterChange(params);
              }}
              onSortChanged={(params) => {
                const updatedSortModel = params.columnApi
                  ?.getColumnState()
                  .filter((col) => !!col.sort)
                  .map((col) => ({ colId: col.colId, sort: col.sort }));
                // const sortModalFromLocal =

                if (updatedSortModel.length > 0) {
                  // this code is to fix the bug where savedModel has the colId as workordernumber_1
                  updatedSortModel[1] = _.cloneDeep(updatedSortModel[0]);
                  if (updatedSortModel[0].colId.endsWith('_1')) {
                    updatedSortModel[1].colId = updatedSortModel[1].colId.substr(
                      0,
                      updatedSortModel[1].colId.length - 2
                    );
                  } else {
                    updatedSortModel[1].colId = `${updatedSortModel[1].colId}_1`;
                  }
                }

                this.updateUserConfigFun('TASK_LIST', {
                  [LOCAL_STORAGE_TASK_LIST_SORT_MODEL]: JSON.stringify(updatedSortModel),
                });
              }}
              onDisplayedColumnsChanged={onDisplayedColumnsChanged(
                LOCAL_STORAGE_TASK_TABLE_COLUMN_VISIBILITY_KEY,
                this.updateUserConfigFun,
                'TASK_LIST'
              )}
              onDragStopped={onDragStopped(
                LOCAL_STORAGE_TASK_LIST_TABLE_ORDER_KEY,
                LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY,
                this.updateUserConfigFun,
                'TASK_LIST'
              )}
              onColumnResized={onColumnResized(
                LOCAL_STORAGE_TASK_TABLE_COLUMN_WIDTH_KEY,
                this.updateUserConfigFun,
                'TASK_LIST'
              )}
              onColumnPinned={onColumnPinned(
                LOCAL_STORAGE_TASK_PIN_COLUMN_LIST,
                this.updateUserConfigFun,
                'TASK_LIST',
                userConfig
              )}
              icons={{
                groupExpanded: '<i class="fa fa-chevron-down"></i>',
                groupContracted: '<i class="fa fa-chevron-right"></i>',
                menu: '<i class="fa fa-filter"></i>',
                checkboxChecked: '<i class="fa fa-check-square ag-grid-checkbox"></i>',
              }}
              suppressColumnVirtualisation
            />
          </div>
          {deleteTaskModal.open && (
            <DeleteRecurrenceTaskConfirmModal
              onClose={this.closeDeleteRecurringTaskModal}
              deleteTaskRecurrence={this.deleteTaskRecurrence}
              task={deleteTaskModal.task}
              dependency={deleteTaskModal.isdependent}
            />
          )}

          <ConfirmTasksModal ref={this.confirmTasksModalRef} />
        </div>
        {saveModal.open && (
          <FilterSaveModal
            saveModal={saveModal}
            handleToggleSaveFilter={this.handleToggleSaveFilter}
            filterModal={filterModal}
            handleSaveFilter={this.handleSaveFilter}
            selectedFilter={selectedFilter}
            taskListGridApi={this.taskListApi}
            allTaskFilters={allTaskFilters}
          />
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const taskAttributes = (state.globalAttributeReducer.attributes || []).filter((attr) => attr.entityType === 'task');
  return {
    allTasks: state.taskViewPageReducer.tasks.items,
    globalTaskAttributes: taskAttributes,
    allFilters: state.taskViewPageReducer.filters.items,
    selectedFilter: state.appReducer.selectedFilter,
    tempCreatedFilter: state.appReducer.tempCreatedFilter,
    parentChildTasks: state.taskViewPageReducer.parentChildTasks,
    userConfig: state.appReducer.initialUserConfig,
    loggedInUser: state.appReducer.loggedInUser,
    settings: state.appReducer.settings,
    selectedFieldId: state.appReducer.selectedField?.id,
    selectedDateRange: state.taskViewPageReducer.selectedDateRange,
  };
}

function mapActionToProps(dispatch) {
  return {
    resetViewInNavigationComponent: bindActionCreators(resetView, dispatch),
    pushViewInNavigationComponent: bindActionCreators(pushView, dispatch),
    updateDeletedForRecurrenceDateForTaskAction: bindActionCreators(updateDeletedForRecurrenceDateForTask, dispatch),
    deleteTaskAction: bindActionCreators(deleteTask, dispatch),
    taskViewAction: bindActionCreators(taskViewPageActions, dispatch),
    changeSelectedFilter: bindActionCreators(changeFilter, dispatch),
    changeTempFilter: bindActionCreators(changeTempfilter, dispatch),
    updateUserConfig: bindActionCreators(updateUserConfig, dispatch),
    parentTaskCardAction: bindActionCreators(parentTaskCardActions, dispatch),
  };
}

TaskList.propTypes = {
  tempCreatedFilter: PropTypes.object,
  onGridReady: PropTypes.func.isRequired,
  parentChildTasks: PropTypes.array,
  rowData: PropTypes.arrayOf(PropTypes.object),
  tasksEditMode: PropTypes.string.isRequired,
  setManageTaskView: PropTypes.func.isRequired,
  selectedUserIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  onRowSelectionChanged: PropTypes.func.isRequired,
  resetViewInNavigationComponent: PropTypes.func.isRequired,
  pushViewInNavigationComponent: PropTypes.func.isRequired,
  allTasks: PropTypes.arrayOf(PropTypes.object).isRequired,
  updateDeletedForRecurrenceDateForTaskAction: PropTypes.func.isRequired,
  deleteTaskAction: PropTypes.func.isRequired,
  globalTaskAttributes: PropTypes.arrayOf(PropTypes.object).isRequired,
  allFilters: PropTypes.arrayOf(PropTypes.object).isRequired,
  filterTasksData: PropTypes.any,
  taskViewAction: PropTypes.shape({
    upsertFilter: PropTypes.func.isRequired,
    deleteFilter: PropTypes.func.isRequired,
    startPageLoadingTask: PropTypes.func.isRequired,
    stopPageLoadingTask: PropTypes.func.isRequired,
    bulkDeleteTasks: PropTypes.func.isRequired,
  }),
  taskViewReducerAction: PropTypes.shape({
    getChildTasksForParentTaskCard: PropTypes.func.isRequired,
  }),
  currentView: PropTypes.string.isRequired,
  selectedFilter: { id: PropTypes.string.isRequired, name: PropTypes.string.isRequired },
  changeSelectedFilter: PropTypes.func.isRequired,
  changeFilter: PropTypes.func,
  changeTempFilter: PropTypes.func.isRequired,
  selectedTasks: PropTypes.array.isRequired,
  userConfig: PropTypes.any,
  updateUserConfig: PropTypes.func,
  loggedInUser: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }),
  settings: PropTypes.object,
  selectedFieldId: PropTypes.string.isRequired,
  selectedAreas: PropTypes.arrayOf(PropTypes.object).isRequired,
  myWatchlist: PropTypes.shape({
    myWatchlistTaskIds: PropTypes.arrayOf(PropTypes.string).isRequired,
    selected: PropTypes.bool.isRequired,
  }),
  handleMyWathlistTaskIds: PropTypes.func,
  setIsPageLoading: PropTypes.func,
  selectedDateRange: PropTypes.exact({
    startDate: PropTypes.any,
    endDate: PropTypes.any,
  }),
};

export default connect(mapStateToProps, mapActionToProps, null, { forwardRef: true })(TaskList);
